import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Check, Phone, ArrowRight } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
const plans = [{
  key: 'start',
  name: 'START',
  tagline: 'Automatiza tu atención.',
  setupPrice: '$900.000',
  monthlyPrice: '$250.000',
  featured: false,
  features: ['IA por WhatsApp', 'Base de conocimiento', 'Servicios, precios y horarios', 'Preguntas frecuentes (FAQs)', 'Captura de datos', 'Transferencia a humano', 'CRM básico', 'Automatizaciones básicas'],
  cta: 'Quiero START'
}, {
  key: 'growth',
  name: 'GROWTH',
  tagline: 'Automatiza tu atención y tus ventas.',
  setupPrice: '$1.800.000',
  monthlyPrice: '$500.000',
  featured: true,
  badge: 'MÁS ELEGIDO',
  features: ['IA por WhatsApp (texto y audio)', 'Calificación avanzada de leads', 'CRM completo', 'Google Calendar integrado', 'Agendamiento automático', 'Confirmación de citas', 'Recordatorios y seguimiento', 'Reactivación de leads fríos', 'Dashboard completo'],
  cta: 'Quiero GROWTH'
}, {
  key: 'pro',
  name: 'PRO',
  tagline: 'Automatiza todo tu proceso comercial.',
  setupPrice: '$3.000.000',
  monthlyPrice: '$900.000',
  featured: false,
  features: ['Todo lo incluido en GROWTH', 'Lead scoring', 'Automatizaciones avanzadas', 'Multi-canal', 'Integraciones avanzadas', 'Dashboard avanzado', 'Automatizaciones personalizadas', 'Soporte prioritario'],
  cta: 'Quiero PRO'
}];
const voiceFlow = ['Llamada entrante', 'ORIGEN AI', 'Identificación', 'Calificación', 'Agenda', 'Confirmación'];
export function Pricing() {
  return <section id="precios" className="bg-arena py-[72px] md:py-[120px]" data-id="element-264" data-mp="3ez2wc04cjnpo">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-265" data-mp="3jxnwy0nig9en">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-12 md:mb-16 text-center max-w-[600px] mx-auto" data-id="element-266" data-mp="r24j0xh9665q">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-267" data-mp="19zynqzbclvib">
            PRECIOS
          </span>
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon leading-[1.1] mb-4" data-id="element-268" data-mp="1502unv46vohj">
            Elige el sistema que tu empresa necesita hoy.
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-carbon/60 leading-[1.6]" data-id="element-269" data-mp="1esibuq7nw91d">
            Implementación única + suscripción mensual. Sin contratos largos,
            sin letra pequeña.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start" data-id="element-270" data-mp="27egeaq13zjts">
          {plans.map((plan, idx) => <motion.div key={plan.key} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: idx * 0.08
        }} className={`relative rounded-[12px] p-8 md:p-10 flex flex-col h-full transition-all duration-200 ${plan.featured ? 'bg-verde text-arena md:-translate-y-3 shadow-cta border border-verde' : 'bg-arena-dark text-carbon border border-salvia/25 hover:border-verde/50 hover:-translate-y-[2px] hover:shadow-card'}`} data-id="element-271" data-mp="2cdt9by24vx7g" data-mpi={idx}>
              {plan.badge && <span className="absolute -top-3 left-8 bg-azul text-arena font-body text-[11px] font-semibold uppercase tracking-[0.1em] px-3 py-1 rounded-full" data-id="element-272" data-mp="12lx3rgko0hfg">
                  {plan.badge}
                </span>}
              <h3 className={`font-display text-[24px] font-bold mb-2 ${plan.featured ? 'text-arena' : 'text-carbon'}`} data-id="element-273" data-mp="svc5ju8wlex2">
                {plan.name}
              </h3>
              <p className={`font-body text-[15px] font-medium mb-6 ${plan.featured ? 'text-arena/85' : 'text-carbon/70'}`} data-id="element-274" data-mp="junsb1rc3il8">
                {plan.tagline}
              </p>

              <div className="mb-6" data-id="element-275" data-mp="a0dydfmquc8e">
                <div className="flex items-baseline gap-1.5" data-id="element-276" data-mp="509hvplu5hi6">
                  <span className={`font-display text-[28px] font-bold ${plan.featured ? 'text-arena' : 'text-carbon'}`} data-id="element-277" data-mp="51uctgc2b2gk">
                    {plan.setupPrice}
                  </span>
                  <span className={`font-body text-[13px] ${plan.featured ? 'text-arena/60' : 'text-carbon/50'}`} data-id="element-278" data-mp="27v1a3fj6oou0">
                    implementación
                  </span>
                </div>
                <div className="flex items-baseline gap-1.5 mt-1" data-id="element-279" data-mp="2go4njnttx1on">
                  <span className={`font-display text-[18px] font-semibold ${plan.featured ? 'text-arena' : 'text-carbon'}`} data-id="element-280" data-mp="2lmft3md3cq12">
                    {plan.monthlyPrice}
                  </span>
                  <span className={`font-body text-[13px] ${plan.featured ? 'text-arena/60' : 'text-carbon/50'}`} data-id="element-281" data-mp="1sy0kbhkjz3y6">
                    / mes
                  </span>
                </div>
              </div>

              <div className={`h-px w-full mb-6 ${plan.featured ? 'bg-arena/20' : 'bg-carbon/10'}`} data-id="element-282" data-mp="39bh6lo0s6rd7" />

              <div className="space-y-3 mb-8 flex-grow" data-id="element-283" data-mp="3e9sevubfgttb">
                {plan.features.map(feature => <div key={feature} className="flex items-start gap-2.5" data-id="element-284" data-mp="2ol4wvig1a2z6">
                    <Check size={15} className={`mt-0.5 flex-shrink-0 ${plan.featured ? 'text-arena/80' : 'text-verde'}`} data-id="element-285" data-mp="2jnv01hqbep1b" />
                    <p className={`font-body text-[14px] leading-[1.5] ${plan.featured ? 'text-arena/85' : 'text-carbon/70'}`} data-id="element-286" data-mp="2tlsoa586cltx">
                      {feature}
                    </p>
                  </div>)}
              </div>

              <a href={getWhatsAppLink(`Hola, equipo de Origen Studio. Quiero el plan ${plan.name} para automatizar mi empresa.`)} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] transition-all duration-200 ${plan.featured ? 'bg-arena text-verde hover:bg-[#EAE7E0]' : 'bg-verde text-arena hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta'}`} data-id="element-287" data-mp="2flrmmnk35ade">
                {plan.cta} <ArrowRight size={15} className="ml-1.5" data-id="element-288" data-mp="3jxcr71pg364f" />
              </a>
            </motion.div>)}
        </div>

        {/* VOICE add-on module */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut',
        delay: 0.2
      }} className="mt-10 md:mt-12 bg-carbon rounded-[12px] p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-8" data-id="element-289" data-mp="gfunn6gpgl9t">
          <div className="flex-1" data-id="element-290" data-mp="2w7a4700e0qco">
            <span className="inline-flex items-center gap-1.5 font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-3" data-id="element-291" data-mp="3ntigg6m4evdy">
              <Phone size={12} data-id="element-292" data-mp="3ite0qit1e4os" /> MÓDULO ADICIONAL
            </span>
            <h3 className="font-display text-[22px] md:text-[26px] font-bold text-arena mb-2" data-id="element-293" data-mp="3eskdzsrbyvxh">
              ¿Y si además pudiera atender tus llamadas?
            </h3>
            <p className="font-body text-[15px] text-arena/60 mb-5 max-w-[420px]" data-id="element-294" data-mp="39vtz38r9i6dn">
              ORIGEN VOICE responde y califica tus llamadas entrantes igual
              que lo hace por WhatsApp.
            </p>
            <div className="flex flex-wrap items-center gap-1.5 mb-5" data-id="element-295" data-mp="6fejbckjt7uq">
              {voiceFlow.map((step, idx) => <Fragment key={step} data-id="element-296" data-mp="3ssv8r6vrgunx" data-mpi={idx}>
                  <span className="font-body text-[12px] text-arena/70 bg-arena/10 rounded-full px-3 py-1.5" data-id="element-297" data-mp="3srtqoigbv7wp">
                    {step}
                  </span>
                  {idx < voiceFlow.length - 1 && <span className="text-arena/30 text-[12px]" data-id="element-298" data-mp="palfuik0p8bh">→</span>}
                </Fragment>)}
            </div>
            <p className="font-body text-[14px] font-medium text-arena/80" data-id="element-299" data-mp="11lm5nthytwcy">
              +$500.000 implementación · +$350.000 / mes
            </p>
          </div>
          <a href={getWhatsAppLink('Hola, equipo de Origen Studio. Quiero agregar el módulo VOICE a mi sistema.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-arena text-carbon font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] hover:bg-[#EAE7E0] transition-colors duration-200 flex-shrink-0" data-id="element-300" data-mp="16nl9f4hmavaf">
            Agregar VOICE <ArrowRight size={15} className="ml-1.5" data-id="element-301" data-mp="1u9i00rk2bc6k" />
          </a>
        </motion.div>

        <p className="text-center font-body text-[13px] text-carbon/40 italic mt-8" data-id="element-302" data-mp="1ydfwsvlx0awg">
          Todos los planes incluyen configuración inicial guiada por el
          equipo de Origen Studio.
        </p>
      </div>
    </section>;
}